export default "__VITE_ASSET__DMdWSZcp__"